import styled from "styled-components";
import {
  FlexColumn,
  FlexColumnCenter,
  FlexRowSpaced,
} from "../../../../../../Common/Styles";

export const Container = styled(FlexColumn)`
  position: relative;
  padding: ${({ theme }) => theme.spacing["spacing-none"].value}rem
    ${({ theme }) => theme.spacing["spacing-4"].value}rem;
`;

export const ColorPickerContainer = styled(FlexRowSpaced)`
  border: ${({ theme }) => theme.border_width["border-width-thin"].value}rem
    solid ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  padding: 3px ${({ theme }) => theme.spacing["spacing-1"].value}rem 3px
    ${({ theme }) => theme.spacing["spacing-3"].value}rem;
`;

export const SelectedColor = styled.div<{ $background: string }>`
  width: ${({ theme }) => theme.spacing["spacing-6"].value}rem;
  height: ${({ theme }) => theme.spacing["spacing-6"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  background: ${({ $background }) => $background};
`;

export const Image = styled.img<{ $isSuccessModal: boolean }>`
  display: ${({ $isSuccessModal }) => ($isSuccessModal ? "block" : "none")};
`;

export const CloseButtonContainer = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  right: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  z-index: 1;
`;

export const Wrapper = styled(FlexColumnCenter)`
  padding: ${({ theme }) => theme.spacing["spacing-4"].value}rem;
  background-color: ${({ theme }) =>
    theme.Color.elevation.surface["surface-primary"].value};
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  border: ${({ theme }) => theme.border_width["border-width-thin"].value}rem
    solid ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
  box-shadow: ${({ theme }) => theme.boxShadows["box-shadow-m"]};
`;

export const RelativeContainer = styled.div`
  position: relative;
`;
